












































































































































import { UserStore } from '@/store/modules/user';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import AMSBreadcrumb from '../../components/AMSBreadcrumb.vue';
import AMSformTable from '../../components/AMSformTable.vue';
import request from '@/utils/request';
import Utils from '@/utils/utils';
import { AppStore } from '../../store/modules/app';
import AMSDialog from '@/components/AMSDialog.vue';
import { emptyRule } from '@/utils/rules';
import AMSProduct from '../../components/AMSProductCategorySelector.vue';
import utils from '@/utils/utils';
import { allStaff } from '@/api/staff';
import { getModuleName } from '@/utils/utils';
import { QueryStore } from '@/store/modules/query';
import moment from 'moment';
interface Form { 
  keyFilter?: string;
  receiverFilter?: string;
  state?: string;
  beginTime: string;
  endTime: string;
  salesId?: string | null
  beautyAdvisorsId: string | null
}

interface IstaffItem{
  id:string
  name:string
  value?:string
  text?:string,
  isActive:Boolean,
  isAdmin: Boolean,
  isSuperAdmin: Boolean,
  phone:string,
  remark: string,
  role:string,
  userId: string,
}

interface IstaffData{
  items?: IstaffItem[]
}
@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-formtable': AMSformTable,
    'ams-dialog': AMSDialog,
    'ams-product': AMSProduct
  }
})
export default class orderList extends Vue {
  public $refs!: {
    formtable: HTMLFormElement;
    form: HTMLFormElement;
    BeginTimeText: HTMLFormElement;
    EndTimeText: HTMLFormElement;
  };
  valid: boolean = true;
  confirmMemo: string | null = ''; //弹框备注
  nameRules: Array<any> = [emptyRule('备注')];
  confirmDialog: boolean = false;
  confirmLoading: boolean = false;
  modalTitle: string = '';
  modalContent: string = '';
  modalIcon: string = '';
  modalApiType: string = '';
  orderId: string = '';
 form: Form =  { 
    state: '', 
    keyFilter: '', 
    receiverFilter: '', 
    beginTime: '', 
    endTime: '', 
    salesId: null, 
    beautyAdvisorsId:null 
  };
  refreshloading: boolean = false;
  staffItem: Array<any> = [{ text: '全部', value: null }];
  get minDate() {
    return this.form.beginTime;
  }
  BreadItem = [
    {
      text: '订单管理',
      disabled: false,
      href: 'orderList'
    },
    {
      text: '订单列表',
      disabled: true
    }
  ];
  api = '/api/Order/List';
  FilterItem = [
    { name: '全部', id: '', count: 'totalCount' },
    { name: '待确认', id: 'PendingConfirm', count: 'pendingConfirmCount' },
    { name: '待审核', id: 'Pending', count: 'pendingCount' },
    { name: '待发货', id: 'Order ', count: 'orderCount' },
    { name: '部分发货', id: 'PartialDelivery ', count: 'partialDeliveryCount' },
    { name: '已完成', id: 'Finished', count: 'finishedCount' }
  ];
  headers: object[] = [
    { text: '订单编号', align: 'left', sortable: false, value: 'number', width: 160, status: 'state' },
    { text: '提交时间', align: 'left', isFormatDateTime: true, sortable: false, value: 'creationTime', width: 200, status: 'state' },
    {
      text: '客户信息',
      align: 'left',
      width: 150,
      sortable: false,
      render: (h: any, param:{ row:any }) => {
        return h('div', { ...utils.stausRenderDiableColor(param.row.state) }, `${param.row.customer.name}   ${param.row.customer.phone}`);
      }
    },
    {
      text: '销售',
      align: 'left',
      value: 'salesName',
      width: 150,
      status: 'state',
       render: (h: any, params: { row:any }) => {
        let text = ''
        params.row.salesName.split(',').forEach((item: any)  => {
          text += `${item}`
          text += '<br />'
        })
          return h('div', {
          domProps: {
            innerHTML: text
          },
          ...Utils.stausRenderDiableColor(params.row.state)
        })
      },
    },
    {
      text: '美导',
      align: 'left',
      value: 'beautyAdvisorsName',
      width: 150,
      status: 'state',
      render:(h: any, params: any) => {
        let text = ''
        params.row.beautyAdvisorsName.split(',').forEach((item: string)  => {
          text += `${item}`
          text += '<br />'
        })
          return h('div', {
          domProps: {
            innerHTML: text
          },
          ...Utils.stausRenderDiableColor(params.row.state)
        })
      },
    },
    { text: '订单金额', align: 'right', value: 'price', isCurrency: true, width: 80, sortable: false, status: 'state' },
    {
      text: '订单状态',
      align: 'left',
      render: (h: any, param: any) => {
        return h(
          'span',
          {
            style: {
              color: this.switchStatus(param.row.state)!.color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(param.row.state)!.text
        );
      },
      width:80,
      sortable: false
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      width: 140,
      sortable: false,
      isDetail: [
        {
          routerName: 'orderList_details',
          text: '确认',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.OrderList.Confirm');
            return permFlag && row.state === 'PendingConfirm';
          }
        },
        {
          routerName: 'orderList_details',
          text: '审核',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.OrderList.Review');
            return permFlag && row.state === 'Pending';
          }
        },
        {
          routerName: 'orderList_details',
          text: '发货',
          color: '#1ABC9C',
          isParams: true,
          query: { tabActive: 'Ship' },
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.AllocationList') || Utils.isPermission('OrderManager.ShipmentList');
            return permFlag && (row.state === 'Order' || row.state === 'PartialDelivery');
          }
        },
        {
          routerName: 'orderList_details',
          text: '查看',
          color: '#1ABC9C',
          isParams: true
        },
        {
          callBack: (btn: object, row: any, key: string) => {
            this.showConfirm(btn, row, key, 'cancel');
          },
          text: '取消',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.OrderList.Cancel');
            return permFlag && (row.state !== 'Finished' && row.state !== 'Canceled');
          }
        },
        {
          callBack: (btn: object, row: any, key: string) => {
            this.showConfirm(btn, row, key, 'delete');
          },
          text: '删除',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            let permFlag = Utils.isPermission('OrderManager.OrderList.Delete');
            return permFlag && row.state === 'Canceled';
          }
        }
      ]
    }
  ];
  beginTime = false;
  endTime = false;
  lastTime = '';
  startTime = '';
  date = new Date().toISOString().substr(0, 10);
  intData = {};
  

  created() {
    if(UserStore.isExternalShipper){//外部仓库发货员 角色账号下不显示订单金额
       this.headers.splice(5,1)
    }
    this.form.state = this.$store.state.app.orderState || '';
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.startTime = this.form.beginTime?moment(this.form.beginTime).format('YYYY-MM-DD'):'';
      this.lastTime = this.form.endTime?moment(this.form.endTime).format('YYYY-MM-DD'):'';
    }
  }
  mounted() {
    this.getStaff();
  }
  getStaff(){
    allStaff({ isActive: true, permissionCheck: true }).then((data:any)  => {
      this.staffItem = [{ value: null, text: '全部' }].concat(
        data.items.map((i:IstaffItem) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }
  onSalesIdClear() {
    setTimeout(() => {
      this.form.salesId = null;
    }, 1);
  }
  onBeautyAdvisorsIdClear() {
    setTimeout(() => {
      this.form.beautyAdvisorsId = null;
    }, 1);
  }
  confirmClose() {
    this.confirmDialog = false;
    this.confirmMemo = null;
  }
  confirmSure() {
    if (this.modalApiType == 'delete') {
      this.deleteOrder();
    } else if ((this.$refs.form as HTMLFormElement ).validate()) {
      this.cancelOrder();
      this.confirmDialog = false;
    }
  }
  cancelOrder() {
    request
      .post(`/api/Order/${this.orderId}/Cancel`, { orderId: this.orderId, remark: this.confirmMemo })
      .then(data => {
        this.confirmDialog = false;
        (this.$refs.formtable as HTMLFormElement).query();
        this.confirmMemo = '';
      })
      .catch(() => {
        this.confirmMemo = '';
        this.confirmDialog = false;
      });
  }
  deleteOrder() {
    request.del(`/api/Order/${this.orderId}`, { orderId: this.orderId }).then(data => {
      this.confirmDialog = false;
      (this.$refs.formtable as HTMLFormElement).query();
      this.confirmMemo = '';
    });
  }
  showConfirm(btn: object, row:{ item:{ state:string, id:string } }, key: string, type: string) {
    // (this.$refs.form as any).resetValidation();
    this.modalApiType = type;
    this.orderId = row.item.id;
    this.modalIcon = 'warning';
    if (type == 'cancel') {
      this.modalTitle = '取消订单';
    } else {
      this.modalTitle = '删除订单';
      this.modalContent = '确定删除该订单吗？';
      this.modalIcon = 'error';
    }
    if (row.item.state == 'PendingConfirm' || row.item.state == 'Pending' || row.item.state == 'Order') {
      this.modalContent = '确定取消该订单吗？';
    } else if (row.item.state == 'PartialDelivery') {
      this.modalContent = '商品已部分发货，确定取消未发货的商品，取消后，已出库的商品将取消出库并释放库存';
    }
    this.confirmDialog = true;
  }
  clickFilter(id: string) {
    this.form.state = id;
    AppStore.Update_OrderState(this.form.state);
    (this.$refs.formtable as HTMLFormElement).query(true);
  }
  OtherDataGet(value: object) {
    this.intData = value;
  }
  refresh() {
    this.refreshloading = true;
    (this.$refs.formtable as HTMLFormElement).query();
    setTimeout(() => {
      this.refreshloading = false;
    }, 500);
  }
  initForm() {
    this.form = {
      keyFilter: '',
      receiverFilter: '',
      state: '',
      beginTime: '',
      endTime: '',
      salesId: null,
      beautyAdvisorsId: null
    };
    this.lastTime =''
    this.startTime =''
    // AppStore.Update_OrderState('');
    // QueryStore.Set_query({ [getModuleName(this.$route.name as string)]: { form: {} } });
    this.refresh();
  }
  Export() {
    let params: { [key: string]: any } = this.form;
    request
      .download('/api/Order/Exprot', { ...params })
      .then(response => {
        AppStore.ShowSuccess('下载成功');
      })
      .catch(error => {
        AppStore.ShowError('下载失败');
      });
  }
  switchStatus(status: string) {
    switch (status) {
      case 'Pending':
        return { color: '#FE5500', text: '待审核' };
      case 'PendingConfirm':
        return { color: '#FF0000', text: '待确认' };
      case 'PartialDelivery':
        return { color: '#FF0000', text: '部分发货' };
      case 'Order':
        return { color: '#FF0000', text: '待发货' };
      case 'Finished':
        return { color: '#00A854', text: '已完成' };
      case 'Canceled':
        return { color: '#999999', text: '已关闭' };
    }
  }

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as HTMLFormElement).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as HTMLFormElement).blur();
  }
  @Watch('lastTime', { immediate: true, deep: true })
  onStartTimeStrChange(newValue: string, oldValue: string) {
    this.form.endTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('startTime', { immediate: true, deep: true })
  onEndTimeStrChange(newValue: string, oldValue: string) {
    this.form.beginTime = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('beginTime', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as HTMLFormElement;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('endTime', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as HTMLFormElement;
    if (text && newValue == false) {
      text.focus();
    }
  }
  @Watch('form', { immediate: true, deep: true })
  formChange(newValue: Object, oldValue: Object) {
    // let moduleName = this.$store.state.query.searchData[getModuleName(this.$route.name as string)];
    // this.form = moduleName ? moduleName.form : {};
    // QueryStore.Set_query({ [getModuleName(this.$route.name as string)]: { form: this.form } });
  }
}
